// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AppIndexPage_wrapper__1kRXT"};